import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import Scanner from "@/pages/Scanner";
import Signals from "@/pages/Signals";
import SignalDetail from "@/pages/SignalDetail";
import Charts from "@/pages/Charts";
import PaperTrading from "@/pages/PaperTrading";
import Journal from "@/pages/Journal";
import Calculator from "@/pages/Calculator";
import CalendarPage from "@/pages/CalendarPage";
import AIAnalysis from "@/pages/AIAnalysis";
import Settings from "@/pages/Settings";
import Backtest from "@/pages/Backtest";
import AdminApp from "@/admin/AdminApp";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center label-xs" data-testid="auth-loading">Loading Fx Cotrader…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

const routes = [
  ["/", Dashboard], ["/scanner", Scanner], ["/signals", Signals], ["/signal/:pair", SignalDetail], ["/charts", Charts],
  ["/paper", PaperTrading], ["/journal", Journal], ["/calculator", Calculator], ["/calendar", CalendarPage],
  ["/ai", AIAnalysis], ["/settings", Settings], ["/backtest", Backtest]
];

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/admin/*" element={<AdminApp />} />
            {routes.map(([p, C]) => <Route key={p} path={p} element={<Protected><C /></Protected>} />)}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="light" position="bottom-right" />
      </AuthProvider>
    </div>
  );
}
